export default __webpack_public_path__ + "static/media/A4 large 7.13a98111.jpg";